import CustomButton from "@components/buttons/CustomButton";
import SignUpCarouselDesktop from "@components/carousel/SignUpCarouselDesktop";
import HomaPageFooter from "@components/footers/HomePageFooter";
import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { getApiErrorDisplay } from "@services/api/apiError";
import { authenticationApiService } from "../../services/apis/Authentication";
import { sendOtpResponse } from "../../services/models/Authentication/Authentication";
import LogoImageComponent from "./components/LogoImageComponent";
import { SignupNoise } from "./components/NoiseUtil";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const continueButtonRef = useRef<HTMLButtonElement>(null);
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      continueButtonRef.current?.click();
    }
  };

  const checkValidEmail = () => {
    if (email.length > 0) {
      const emailRegex = new RegExp(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      );
      if (!emailRegex.test(email)) {
        return false;
      } else {
        return true;
      }
    }
  };

  const handleSubmit = async () => {
    try {
      setIsButtonLoading(true);
      const response: sendOtpResponse = await authenticationApiService.sendOtp(
        email
      );
      const csrfToken = response.data.csrfToken;
      console.log("email", email);
      console.log("csrfToken", csrfToken);
      secureLocalStorage.setItem("loginEmail", email);
      secureLocalStorage.setItem("loginCsrfToken", csrfToken);
      navigate("/verifyOtp", { state: { csrfToken, email } });
      console.log(csrfToken);
    } catch (error) {
      setError(getApiErrorDisplay(error));
    } finally {
      setIsButtonLoading(false);
    }
  };

  const checkLogin = () => {
    const jwt = secureLocalStorage.getItem("jwt");
    if (jwt) {
      navigate("/");
    }
  };

  useEffect(() => {
    checkLogin();
  }, []);

  return (
    <div className="flex bg-[#ffffff] min-h-screen">
      <div
        className="w-[50vw]  bg-text-navbar-active pt-24"
        style={{ backgroundImage: `url(${SignupNoise})` }}
      >
        <SignUpCarouselDesktop />
      </div>
      <div className="w-[50vw] flex flex-col justify-start mt-24 items-center">
        <div className="w-3/4 flex flex-row mb-[40px] items-center justify-center">
          <LogoImageComponent className="h-44 w-44" />
        </div>
        <div className="p-[20px] w-3/4 rounded-[12px]">
          <div className="text-text-base text-[14px] font-semibold mb-4 items-center flex justify-center">
            Login to your dashboard!
          </div>
          <div className="flex flex-col gap-[16px]">
            <GlobalTextInputField
              placeholder="Email id"
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEmail(e.target.value)
              }
              fontSize="14px"
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="my-4">
            <CustomButton
              ref={continueButtonRef}
              text="CONTINUE"
              onClick={handleSubmit}
              isActive={checkValidEmail() ? true : false}
              isButtonLoading={isButtonLoading}
            />
          </div>
          {error && (
            <div className="flex flex-row items-center">
              <span className="material-symbols-outlined mr-1 text-[20px] text-text-status-red">
                warning
              </span>
              <p className="text-text-status-red text-[12px] font-medium text-center">
                {error}
              </p>
            </div>
          )}
        </div>
        <HomaPageFooter />
      </div>
    </div>
  );
};
export default Login;
